$(document).ready(function() {

    $(".template-2024-about-us h4").attr("role","none");


    
    $(".a11y_click").click(function() {
        $(".mobile-facets__open-wrapper.focus-offset").click();
        $(".mobile-facets__open-wrapper.focus-offset").focus();
    });

    $(".a11y_click").keydown(function(event) {
        if(event.which == 13) {
            $(this).click();
        }
    }); 


    const video = $('video.video-homepage')[0]; // Get the video DOM element
        const playPauseBtn = $('#playPauseBtn');

        // Event listener for button click
        playPauseBtn.on('click', function() {
            if (video.paused) {
                video.play();
                playPauseBtn.text('Pause');
            } else {
                video.pause();
                playPauseBtn.text('Play');
            }
        });


        $('h1:empty, h2:empty, h3:empty, h4:empty, h5:empty, h6:empty').each(function() {
            $(this).replaceWith('<p></p>');
        });

        $('#dialog-wrapper__id [data-ref="cancel"]').attr("aria-label","Cancel");
        $('#dialog-wrapper__id [data-ref="accept"]').attr("aria-label","Accept");
   
    console.log("ready");
});

$(window).on("load", function(){

    $(".video-section iframe.js-youtube").attr("title", "Youtube Video");
    $(".cd-price-reviews h4").attr("role","none");



    setTimeout(function() {
        $("#rebuy-cart h4").attr({"role":"heading","aria-level":"2"});
        $(".rebuy-product-actions .rebuy-button span").attr("aria-live","polite");
        $(".rebuy-cart__flyout-items, .rebuy-product-grid, .rebuy-product-actions .rebuy-button").removeAttr("tabindex");
    }, 3000);



    console.log("load");
});